module.exports = __webpack_public_path__ + "static/img/btc.538a6a48.png";